import { API } from '../params';

export const upload_config_multi_image = {
    name: 'file',
    multiple: true,
    action: API+'/index.php',
    accept: 'image/jpeg,image/png',
    maxCount: 10,
}

export const upload_config_one_image = {
    name: 'file',
    multiple: false,
    action: API+'/index.php',
    accept: 'image/jpeg,image/png',
    maxCount: 1,
}

export const upload_config_one_png_image = {
    name: 'file',
    multiple: false,
    action: API+'/index.php',
    accept: 'image/png',
    maxCount: 1,
}

export const upload_config_multi_pdf = {
    name: 'file',
    multiple: true,
    action: API+'/index.php',
    accept: 'application/pdf',
    maxCount: 10,
}